import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { socketFunc } from "../../../../utils/socketUtil";
import { useParams } from "react-router-dom";
import LeftBarSports from "../../../components/LeftBarSports";
import AppIframe from "../../../components/AppIframe";
import { getLocalToken } from "../../../../utils/axiosService";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";

const ExchangeSPMSportsLobbyPage = () => {
  const [lobbyUrl, setLobbyUrl] = useState();
  const { category } = useParams();
  const token = getLocalToken();

  useEffect(() => {
    try {
      if (token) {
        const socket = socketFunc(token);
        // tab: z.string().optional(),
        // // Layout
        // headless: z.boolean().optional(),
        // sidebarType: z.nativeEnum(SIDERBAR_TYPES).optional(),
        // // Action URLS
        // homeUrl: z.string().url().optional(),
        // depositUrl: z.string().optional(),
        // signUpUrl: z.string().optional(),
        // signInUrl: z.string().optional(),
        // // Sports
        // sportsTypes: z.array(z.number()).optional(), // Allowed sportstypes

        const lobbyConfig = {
          config: {
            launchPage: category,
            theme: "blue-theme",
            // headless: true,
            // tab: "cricket", // soccer, tennis, live, upcomming, favourite,horse
            // homeUrl: pageUrlGenerator("/home"),
            // depositUrl: pageUrlGenerator("/gatewaylist"),
            // signUpUrl: pageUrlGenerator("/mobile-number"),
            // signUsignInUrlpUrl: pageUrlGenerator("/sign-in"),
          },
        };
        socket.emit("get:spmsports_lobby", lobbyConfig, (res) => {
          if (typeof res?.data?.lobby === "string") {
            setLobbyUrl(res?.data?.lobby);
          }
        });
      }
    } catch (err) {
      console.error(err);
      return;
    }
  }, [category]);

  return (
    <>
      <div>
          <HeaderAfterLogin />
      </div>
      <div className="live_casino_page live">
        <div className="home-section">
        

          <AppIframe iframeUrl={lobbyUrl} isRedirectionRequired={false} />

          {/* <BottomNav /> */}
        </div>
      </div>
    </>
  );
};

export default ExchangeSPMSportsLobbyPage;
